enum TriggerSourceType {
	DeviceTrigger = 'DeviceTrigger',
	ScheduleTrigger = 'ScheduleTrigger',
}
export default TriggerSourceType;
